// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsChat-ChatForm-ChatMsgList-ChatMsgGroup-ReplyMsg-ReplyMsg-module__reply--MpYZy {
  position: relative;
  margin-left: 10px;
  padding-left: 8px;
  font-size: 12px;
  line-height: 18px;
  color: #0000008c;
}
.src-businessServices-services-bsChat-ChatForm-ChatMsgList-ChatMsgGroup-ReplyMsg-ReplyMsg-module__reply--MpYZy::before {
  content: "";
  position: absolute;
  left: 0;
  width: 1px;
  top: 2px;
  bottom: 2px;
  background: #0000008c;
}
.src-businessServices-services-bsChat-ChatForm-ChatMsgList-ChatMsgGroup-ReplyMsg-ReplyMsg-module__replyContent--jobjk > div {
  display: inline;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsChat/ChatForm/ChatMsgList/ChatMsgGroup/ReplyMsg/ReplyMsg.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;AACJ;AAIE;EACE,eAAA;AAFJ","sourcesContent":[".reply {\n  position: relative;\n  margin-left: 10px;\n  padding-left: 8px;\n  font-size: 12px;\n  line-height: 18px;\n  color: #0000008c;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    width: 1px;\n    top: 2px;\n    bottom: 2px;\n    background: #0000008c;\n  }\n}\n\n.replyContent {\n  & > div {\n    display: inline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reply": `src-businessServices-services-bsChat-ChatForm-ChatMsgList-ChatMsgGroup-ReplyMsg-ReplyMsg-module__reply--MpYZy`,
	"replyContent": `src-businessServices-services-bsChat-ChatForm-ChatMsgList-ChatMsgGroup-ReplyMsg-ReplyMsg-module__replyContent--jobjk`
};
export default ___CSS_LOADER_EXPORT___;
